// helper.ts

interface T_TODO {
  todo: number;
  // doing: number;
  done: number;
}

export function read_todo(data: any): T_TODO {
  var res: T_TODO = {
    todo: 0,
    // doing: 0,
    done: 0,
  };

  let name = "작업 전";
  if (data[name] !== undefined) {
    res.todo += data[name];
    delete data[name];
  }

  name = "작업중";
  if (data[name] !== undefined) {
    // res.doing += data[name];
    res.todo += data[name];
    delete data[name];
  }

  name = "작업 완료";
  if (data[name] !== undefined) {
    res.done += data[name];
    delete data[name];
  }

  name = "수정 보류";
  if (data[name] !== undefined) {
    res.done += data[name];
    delete data[name];
  }

  name = "추가 개선 요청";
  if (data[name] !== undefined) {
    res.todo += data[name];
    delete data[name];
  }

  name = "논의 필요";
  if (data[name] !== undefined) {
    res.todo += data[name];
    delete data[name];
  }

  name = "재 확인";
  if (data[name] !== undefined) {
    res.todo += data[name];
    delete data[name];
  }

  return res;
}

let is_dev = true;
if (process.env.NODE_ENV != "development") {
  is_dev = true;
}
export const IS_DEV = is_dev;

// axios 대신 fetch 로로
interface WEB_HEADERS {
  [key: string]: string;
}
interface WEB_REQ {
  query?: WEB_HEADERS;
  headers?: WEB_HEADERS;
  body?: any;
}
interface WEB_RES {
  status: number;
  data: any;
}

// axios 대신 fetch 로
export async function web_get(
  url: string,
  req: WEB_REQ = {}
): Promise<WEB_RES> {
  if (req.query) {
    console.log("query");
    const qstr = new URLSearchParams(req.query).toString();
    url += `?${qstr}`;
  }

  var headers = {};
  if (req.headers) {
    headers = req.headers;
  }

  // var status = -999;
  // var p = new Promise<WEB_RES>((resolve, reject) => {
  //   fetch(url, {
  //     // method: "GET",
  //     headers: {
  //       ...headers,
  //     },
  //   })
  //     .then((response) => {
  //       console.log("res ok");
  //       status = response.status;
  //       return response.json();
  //     })
  //     .then((data) =>
  //       resolve({
  //         status: status,
  //         data,
  //       })
  //     )
  //     .catch((err) => reject(err));
  // });
  // return p;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      ...headers,
    },
  });
  if (response.ok === false) {
    return {
      status: -999,
      data: {},
    };
  }

  const contentType = response.headers.get("content-type");
  console.log("contentType", contentType);

  if (contentType && contentType.includes("application/json")) {
    const data = await response.json();
    return {
      status: 200,
      data,
    };
  } else {
    const text = await response.text();
    return {
      status: 200,
      data: text,
    };
  }
}

// axios 대신 fetch 로
export async function web_post(url: string, req: WEB_REQ = {}) {
  var headers = {};
  if (req.headers) {
    headers = req.headers;
  }
  var body = {};
  if (req.body !== undefined) {
    body = req.body;
  }
  var status = -999;
  var p = new Promise<WEB_RES>((resolve, reject) => {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        status = response.status;
        return response.json();
      })
      .then((data) => {
        resolve({
          status,
          data,
        });
      })
      .catch((err) => reject(err));
  });
  return p;
}
